export default __webpack_public_path__ + "static/media/RTOmenu.7940c872.svg";